const humanReadableDuration = function (minutes: number): string {
    let duration_string = '';
    const hours = Math.floor(minutes / 60);
    if (hours > 0) {
        duration_string += hours.toString() + ' hr. ';
    }
    const mins = minutes % 60;
    if (mins >= 0) {
        duration_string += mins.toString() + ' min. ';
    }

    return duration_string;
};

/**
 * Converts a number of milliseconds to a formatted date string
 * @returns {string} - in the form mm:ss.dd (mm = minutes, ss = seconds, dd = decimals of a second)
 */
export enum DURATION_FORMAT {
    MINUTES_SECONDS_MILLIS = 'mm:ss.ms',
    MINUTES_SECONDS = 'mm:ss',
    MINUTES = 'mm',
}
export const toColonSeparatedDuration = (
    millis: number,
    format = DURATION_FORMAT.MINUTES_SECONDS_MILLIS,
): string => {
    const minutes = Math.floor(millis / (1000 * 60));
    const seconds = Math.floor((millis / 1000) % 60);
    const milliRemainder = Math.floor(millis % 1000);

    const minutesStr = minutes < 10 ? '0' + minutes : minutes;
    const secondsStr = seconds < 10 ? '0' + seconds : seconds;
    const millisStr = milliRemainder.toString()[0];

    switch (format) {
        case DURATION_FORMAT.MINUTES_SECONDS_MILLIS:
            return `${minutesStr}:${secondsStr}.${millisStr}`;
        case DURATION_FORMAT.MINUTES_SECONDS:
            return `${minutesStr}:${secondsStr}`;
        case DURATION_FORMAT.MINUTES:
            return `${minutesStr}`;
        default:
            return `${minutesStr}:${secondsStr}.${millisStr}`;
    }
};

/**
 * Converts a time duration to a number of milliseconds. If the timeStr is user input, you should
 * wrap the function call to fromColorSeparatedDuration in a try-catch, as it will throw errors for
 * incorrectly-formatted strings.
 * @param {string} timeStr - in the format mm:ss.dd (mm = minutes, ss = seconds, dd = decimals of a second)
 * @returns {number} - the number of milliseconds
 */
export const fromColonSeparatedDuration = (timeStr: string) => {
    const [minutesStr, secondMillisecondsStr] = timeStr.split(':');
    const [secondsStr, secondDecimalStr] = secondMillisecondsStr.split('.');
    const subSeconds = parseFloat('0.' + secondDecimalStr);
    const minutes = parseInt(minutesStr);
    const seconds = parseInt(secondsStr);
    if (isNaN(minutes) || isNaN(seconds) || isNaN(subSeconds)) {
        throw Error('Invalid time string format');
    }
    return minutes * 60 * 1000 + seconds * 1000 + subSeconds * 1000;
};

export default humanReadableDuration;
